import "./App.css";
import EighthPage from "./Comps/EighthPage";
import FifthPage from "./Comps/FifthPage";
import FirstPage from "./Comps/FirstPage";
import FourthPage from "./Comps/FourthPage";
import SecondPage from "./Comps/SecondPage";
import SeventhPage from "./Comps/SeventhPage";
import SixthPage from "./Comps/SixthPage";
import ThirdPage from "./Comps/ThirdPage";

function App() {
  return (
    <div className="App">
      <FirstPage />
      <SecondPage />
      <ThirdPage />
      <FourthPage />
      <FifthPage />
      <SixthPage />
      <SeventhPage />
      <EighthPage />
    </div>
  );
}

export default App;
